import { API_ENDPOINTS_URLS } from '../apiendpointurls';
import { serviceRequest } from '../../apihelper';
import { getSessionToken } from '../../../utils/authentication/jwtUtils';

export const UserSigninAPI = (params) => {
    let url = API_ENDPOINTS_URLS.Login;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params)
    }

    return serviceRequest(url, requestOptions);
};

export const userSignUpAPI = (params, signal) => {
    let url = API_ENDPOINTS_URLS.Signup;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params)
    }

    return serviceRequest(url, requestOptions);
};

export const ValidateSessionTokenAPI = (params, signal) => {
    let url = API_ENDPOINTS_URLS.SessionToken;

    let requestOptions = {
        method: 'GET',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);
};

export const ForgotPasswordAPI = (params) => {
    let url = API_ENDPOINTS_URLS.ForgetPassword;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);
};

export const ResetPasswordAPI = (params) => {
    let url = API_ENDPOINTS_URLS.ResetPassword;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);
}

export const ValidateForgotLinkAPI = (params) => {
    let url = API_ENDPOINTS_URLS.ValidateForgotLink;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);

}

export const ChargeCreditCardAPI = (params) => {
    let url = API_ENDPOINTS_URLS.ChargeCreditCard;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);
}

export const GetCardDetailsAPI = (params) => {
    let url = API_ENDPOINTS_URLS.GetCardDetails;

    let requestOptions = {
        method: 'GET',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);
};

export const CompleteSubscriptionAPI = (params) => {
    let url = API_ENDPOINTS_URLS.CompleteSubscription;

    let requestOptions = {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'session-token': getSessionToken('session_token')
        }
    }

    return serviceRequest(url, requestOptions);
}

export const getUserSubscriptionListAPI = () => {
    let url = API_ENDPOINTS_URLS.getUserSubscriptionList;

    let requestOptions = {
        method: 'GET'
    }

    return serviceRequest(url, requestOptions);
};